/* GLOVARA · vidéo « So legen Sie es an » (9 oct 2026, préparé pour la lecture de samedi soir).
   Remplace les deux GIF du mode d'emploi (4 Mo et 0,9 Mo chargés dès l'ouverture de la fiche) par une vidéo MP4
   d'environ 0,3 Mo, sans son, en boucle. Rien n'est téléchargé tant que la vidéo n'est pas à l'écran
   (preload="none") : elle démarre quand elle est visible à moitié et s'arrête quand elle sort de l'écran.
   Si le téléphone refuse la lecture automatique (mode économie d'énergie sur iPhone), l'image fixe reste
   (la sangle posée sous le genou) ; depuis le 11 oct, une animation WebP en boucle la remplace (voir secours()).
   La galerie est redessinée quand on change d'offre (bloc d'achat) : les nouvelles vidéos sont reprises.
   10 oct 2026 (vitesse, theme-sangle-nl_vitesse.py) : l'image fixe n'est plus dans le HTML (attribut
   data-glv-poster au lieu de poster) : un navigateur la téléchargeait dès l'ouverture, en même temps que l'image
   principale de la galerie (environ 110 Ko en tout). Elle est posée ici dès que l'image principale est chargée,
   ou dès que la vidéo approche de l'écran, ou au plus tard à la fin du chargement de la page. */
(function () {
  if (window.glvAnlegen) return;
  window.glvAnlegen = true;

  var vues = new WeakSet();
  var posterLibre = false;

  function poserPoster(v) {
    var p = v.getAttribute('data-glv-poster');
    if (p && !v.getAttribute('poster')) v.setAttribute('poster', p);
  }

  function tousLesPosters() {
    posterLibre = true;
    document.querySelectorAll('video[data-glv-poster]').forEach(poserPoster);
  }

  /* 11 oct 2026 (Ala) : plus jamais de boutons lecture / pause. Si le téléphone refuse la lecture automatique (mode
     économie d'énergie sur iPhone), la vidéo est remplacée par la même scène en animation WebP en boucle
     (data-glv-anim, 0,57 à 0,93 Mo, téléchargée seulement dans ce cas) ; sans animation prévue, l'image fixe reste. */
  function secours(v) {
    var a = v.getAttribute('data-glv-anim');
    v.removeAttribute('controls');
    if (!a || v.getAttribute('data-glv-secours')) return;
    v.setAttribute('data-glv-secours', '1');
    var img = document.createElement('img');
    img.src = a;
    img.alt = v.getAttribute('aria-label') || '';
    img.decoding = 'async';
    img.setAttribute('style', 'display:block;width:100%;height:100%;object-fit:cover;background:#e8ece9');
    img.addEventListener('load', function () { v.style.display = 'none'; }, { once: true });
    v.parentNode.insertBefore(img, v);
  }

  var io = null;
  var proche = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) poserPoster(v);
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          v.muted = true;
          var p = v.play();
          if (p && p.catch) {
            /* commandes seulement si le téléphone refuse la lecture automatique ; pas quand une pause (défilement
               rapide) interrompt la lecture (AbortError), sinon les commandes restaient affichées pour rien */
            p.catch(function (err) { if (err && err.name === 'NotAllowedError') secours(v); });
          }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: [0, 0.5] });
    /* image fixe posée un peu avant que la vidéo n'arrive à l'écran (défilement vers le bas) */
    proche = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) { poserPoster(e.target); proche.unobserve(e.target); }
      });
    }, { rootMargin: '1200px 0px' });
  }

  function equiper(v) {
    if (vues.has(v)) return;
    vues.add(v);
    v.muted = true;
    if (posterLibre) poserPoster(v);
    if (io) { io.observe(v); proche.observe(v); }
    else { poserPoster(v); secours(v); }
  }

  function tout() {
    document.querySelectorAll('video[data-glv-anlegen]').forEach(equiper);
  }

  /* l'image principale de la galerie (priorité haute) passe d'abord ; les images fixes des vidéos ensuite */
  function apresImagePrincipale() {
    var img = document.querySelector('img[fetchpriority="high"]');
    if (!img || img.complete) { tousLesPosters(); return; }
    img.addEventListener('load', tousLesPosters, { once: true });
    img.addEventListener('error', tousLesPosters, { once: true });
  }

  tout();
  apresImagePrincipale();
  window.addEventListener('load', tousLesPosters);
  document.addEventListener('DOMContentLoaded', tout);
  if ('MutationObserver' in window) {
    new MutationObserver(function (liste) {
      for (var i = 0; i < liste.length; i++) {
        if (liste[i].addedNodes && liste[i].addedNodes.length) { tout(); break; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
